/**
 * THIS FILE IS AUTOMATICALLY GENERATED BY genFonts.js.
 *
 * DO NOT MANUALLY MODIFY THIS FILE.
 */

enum FontClass {
  Body1 = "body1Font",
  Body1Bold = "body1BoldFont",
  Body1Medium = "body1MediumFont",
  Body1SemiBold = "body1SemiBoldFont",
  Body2 = "body2Font",
  Body2Bold = "body2BoldFont",
  Body2Medium = "body2MediumFont",
  Body2SemiBold = "body2SemiBoldFont",
  Body3 = "body3Font",
  Body3Bold = "body3BoldFont",
  Body3Medium = "body3MediumFont",
  Body3SemiBold = "body3SemiBoldFont",
  Header1 = "header1Font",
  Header2 = "header2Font",
  Header3 = "header3Font",
  NavLink = "navLinkFont",
  Subheader = "subheaderFont",
  TinyLabel = "tinyLabelFont",
}

export default FontClass;
